export default __webpack_public_path__ + "static/media/online-exam-platform-1.14814ed2.jpg";